import * as React from 'react';
import { LocationSuggest } from '../../../../components/LocationSuggest';
import { ILocation } from '../../../../types/location';
import { useLocationSuggest } from '../../utils/useLocationSuggest';
import { useLocationSuggestValue } from '../../utils/useLocationSuggestValue';
import { useLocationSuggestPopup } from '../../utils/useLocationSuggestPopup';
import { Outside } from '@cian/ui-kit/prev';
import { SubmitButton } from '../../../../components/SubmitButton';
import { useFormTracking } from '../../../../utils/useFormTracking';

export interface ILocationContainerProps {
  location?: ILocation | null;

  onSubmit(): void;

  onLocationChange(location?: ILocation): void;
}

export const LocationContainer: React.FC<ILocationContainerProps> = ({ location, onLocationChange, onSubmit }) => {
  const { isSuggestShown, onItemClick, togglePopup } = useLocationSuggestPopup({ onLocationChange });
  const { trackSubmit } = useFormTracking();

  const { getLocationSuggest, suggest, isFetching } = useLocationSuggest({ togglePopup });

  const { suggestValue, clearSuggestValue, onSuggestionValueChange } = useLocationSuggestValue({
    location,
    onLocationChange,
    togglePopup,
    getLocationSuggest,
  });

  const handleSubmit = React.useCallback(() => {
    onSubmit();

    trackSubmit({
      field: 'region',
      value: location && location.name,
      isRequired: true,
    });
  }, [trackSubmit, location, onSubmit]);

  return (
    <Outside onOutside={clearSuggestValue}>
      <LocationSuggest
        isLoading={isFetching}
        placeholder="Город или регион"
        inputValue={suggestValue}
        suggest={suggest}
        isSuggestShown={isSuggestShown}
        onChange={onSuggestionValueChange}
        onItemClick={onItemClick}
      />

      <SubmitButton disabled={!location} onClick={handleSubmit}>
        Дальше
      </SubmitButton>
    </Outside>
  );
};

LocationContainer.displayName = 'LocationContainer';
